import { isRecentRelease } from "../../verify-release.js";
import { Container } from "./styles.js";

export default function MovieMoov({ movie, movie_person, character, roles, person_id }) {

    const recentRelease = (movie?.release_date?.slice(0, 4) == '2025') && isRecentRelease(movie?.release_date);

    const person_character = movie_person?.cast?.find(person => person?.person_id == person_id)

    return (
        <Container to={`/details/${movie?.media_type}/${movie?.id_tmdb}/${movie?.id_imdb}`} background_color_hover={movie?.background_color} >
            <div className="div-image">
                <img src={`https://image.tmdb.org/t/p/w400${movie?.backdrop_path}`} alt={movie?.title || movie?.name} loading="lazy" />
                {recentRelease && (
                    <div className="new-release-banner">Novidade</div>
                )}
            </div>
            {(person_character?.character || person_character?.roles[0]?.character) &&
                <div className="character-container">
                    <i className="fas fa-user"></i>
                    <span className="character">{person_character?.character?.replace("voice", "voz") || person_character?.roles[0]?.character.replace("voice", "Voz")}</span>
                </div>
            }
            <h2>{movie?.title || movie?.name}</h2>
        </Container>
    );
}
